'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _i18n = require('../services/i18n');

var init = function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var initialState = getInitialState(el);
  var els = getEls(context);
  var locale = (0, _i18n.getLocale)();
  var loading = false;

  // Creates Zendesk Widget script and adds it to the head of document
  var handleClick = function handleClick(evt) {
    evt.preventDefault();
    addWidget();
  };

  var addWidget = function addWidget() {
    if (loading) return;

    loading = true;

    var zendeskScript = document.createElement('script');
    zendeskScript.type = 'text/javascript';
    zendeskScript.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + initialState.key;
    zendeskScript.id = 'ze-snippet';

    zendeskScript.onload = function () {
      el.removeChild(els.button);

      // eslint-disable-next-line
      zE('webWidget', 'setLocale', locale);

      window.zESettings = {
        webWidget: {
          position: { horizontal: 'left', vertical: 'bottom' },
          contactOptions: {
            enabled: true
          }

          // eslint-disable-next-line
        } };zE('webWidget:on', 'open', function () {
        var style = document.createElement('style');
        var iconURL = window.theme.chatIcon;

        if (iconURL) {
          style.innerHTML = '#Embed .label-6AYOW,\n          #Embed .Icon-1QudM {\n            display: none !important;\n          }\n          #Embed div div {\n            position: absolute;\n            left: 20px;\n            bottom: 20px;\n          }\n          #Embed .wrapper-3hgZT {\n            position: relative;\n            left: 0;\n            bottom: 0;\n            background-image: url(' + iconURL + ');\n            background-repeat: no-repeat;\n            background-position: center;\n            background-color: transparent !important;\n            width: 40px;\n            height: 40px;\n            padding: 0;\n          }\n          #Embed .wrapper-3hgZT:focus {\n            box-shadow: none;\n          }\n          #Embed .wrapper-3hgZT::after {\n            content: \'\';\n            position: absolute;\n            top: 0;\n            right: 0;\n            bottom: 0;\n            left: 0;\n            z-index: -1;\n            background-color: #000;\n            border-radius: 50%;\n            -webkit-box-shadow: 2px 4px 8px rgb(0 0 0 / 10%);\n            box-shadow: 2px 4px 8px rgb(0 0 0 / 10%);\n            opacity: 0.8;\n            -webkit-transition: -webkit-transform 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n            transition: -webkit-transform 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n            transition: transform 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n            transition: transform 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55), -webkit-transform 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n          }\n          #Embed .wrapper-3hgZT:hover::after {\n            -webkit-transform: scale(1.1);\n            transform: scale(1.1);\n          }';

          setZendeskStyle(style);
        }
      });

      // eslint-disable-next-line
      zE('webWidget', 'open');
    };

    document.head.appendChild(zendeskScript);
  };

  try {
    els.button.addEventListener('click', handleClick);
  } catch (error) {
    addWidget();
    console.info(error);
  }

  // Sets up styling when widget has launched
  function setZendeskStyle(style) {
    try {
      parent.document.getElementById('launcher').contentDocument.head.appendChild(style);
    } catch (err) {
      setTimeout(function () {
        setZendeskStyle(style);
      }, 300);
    }
  }
}; /**
    * Documentation on Zendesk Widget's settings can be found here:
    * https://developer.zendesk.com/api-reference/widget/settings/
    */

function getEls(context) {
  return {
    button: context.getElement('.' + context.className + '_Button')
  };
}

function getInitialState(el) {
  return {
    key: el.dataset.key
  };
}

exports.init = init;